<template>
  <table class="ui striped selectable table">
    <thead>
      <tr>
        <th></th>
        <th>Class</th>
        <th>Link to Nominations page</th>
        <th>Created on</th>
        <th>Accessible until</th>
        <th># students</th>
        <th>Progress (%)</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="!testList || testList.length == 0">
        <td></td>
        <td colspan="4">No tests found</td>
      </tr>
      <test-table-row
        v-for="test in testList"
        v-bind:test="test"
        v-bind:key="test.Id"
        v-bind:actions="actions"
        v-on:action="rowAction"
      />
    </tbody>
  </table>
</template>

<script>
import TestTableRow from '@/components/tests/TestTableRow';

export default {
  name: 'TestTable',
  computed: {
    testList() {
      return this.tests || null;
    },
  },
  components: { TestTableRow },
  props: ['tests', 'actions'],
  methods: {
    rowAction(action) {
      this.$emit('rowAction', action);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestTable.vue